export const PDF_COLORS = {
  primary: [3, 105, 161],        // #0369a1 Clinical Blue
  primaryDark: [7, 89, 133],     // #075985
  primaryLight: [240, 249, 255], // #f0f9ff
  textDark: [15, 23, 42],        // #0f172a
  textMuted: [71, 85, 105],      // #475569
  border: [203, 213, 225],       // #cbd5e1
  borderLight: [226, 232, 240],  // #e2e8f0
  bgLight: [248, 250, 252],      // #f8fafc
  white: [255, 255, 255],
  success: [22, 101, 52],        // #166534
};

export const PDF_FONTS = {
  family: "helvetica",
  sizes: {
    title: 13,
    subtitle: 9.5,
    section: 10,
    label: 8.5,
    value: 9,
    small: 8,
    footer: 7.5,
  },
};

export const PDF_LAYOUT = {
  format: "a4",
  unit: "pt",
  pageWidth: 595.28,
  pageHeight: 841.89,
  marginX: 36,
  marginTop: 36,
  marginBottom: 40,
  get contentWidth() {
    return this.pageWidth - this.marginX * 2;
  },
};
